export const useSweetAlert = ({ onConfirm, onCancel }) => {
  const handleConfirm = (e) => {
    if (onConfirm) {
      onConfirm(e);
    }
  };

  const handleCancel = (e) => {
    if (onCancel) {
      onCancel(e);
    }
  };

  return {
    handleConfirm,
    handleCancel,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/SweetAlert/hooks/useSweetAlert.js